import { defineMessages } from 'react-intl';

export const mcpSiteSelectorMessages = defineMessages({
  siteLabel: {
    id: 'oauth.mcp.siteSelector.label',
    defaultMessage: 'Site (For Jira, Confluence and other tools)',
    description: 'Label above the site-picker dropdown',
  },
  sitePlaceholder: {
    id: 'oauth.mcp.siteSelector.placeholder',
    defaultMessage: 'Select a site',
    description: 'Placeholder text inside the site-picker dropdown',
  },
  noWorkspacesHeading: {
    id: 'oauth.mcp.siteSelector.noWorkspaces.heading',
    defaultMessage: 'Supported sites required',
    description:
      'Heading shown when the user has no workspaces available in their token',
  },
  noWorkspacesDescription: {
    id: 'oauth.mcp.siteSelector.noWorkspaces.description',
    defaultMessage:
      "Atlassian Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. Your account isn't currently associated with a supported site.  {learnMoreLink}",
    description:
      'Description shown when the user has no workspaces; {learnMoreLink} is a link to Rovo MCP documentation',
  },
  noWorkspacesLearnMore: {
    id: 'oauth.mcp.siteSelector.noWorkspaces.learnMore',
    defaultMessage: 'Understand Rovo MCP Server',
    description:
      'Link text for the Rovo MCP documentation shown when no workspaces are available',
  },
});
